import {Dispatch} from "redux";
import {VehicleListDispatchTypes, VEHICLE_LIST_STORE_STATE} from "./VehicleListActionTypes";
import {RootStore} from "../../Store";
import {getDataFromServiceWithRedux} from "store-fetch-wrappers";
import GrsApiModel from "../../apiModel/GrsApiModel";
import {statusCodeCallback} from "../../helpers/storeHelpers";

/** Nukes store of stale data */
export const nullifyVehicleListStore = () => {
    return async (dispatch: Dispatch<VehicleListDispatchTypes>) => {
        dispatch({
            type: VEHICLE_LIST_STORE_STATE.SUCCESS,
            error: null,
            loading: false,
            data: null
        });
    };
};

/** Gets all vehicles in the database */
export const getAllVehicles = () => {
    return async (dispatch: Dispatch<VehicleListDispatchTypes>, state: () => RootStore) => {
        try {
            await getDataFromServiceWithRedux(
                VEHICLE_LIST_STORE_STATE,
                dispatch,
                () => GrsApiModel.getVehicleApi().listVehicles(),
                statusCodeCallback
            );
            const vehicleList = state().vehicleList.data;
            return vehicleList ? vehicleList.vehicles : [];
        } catch (e: any) {
            dispatch({
                type: VEHICLE_LIST_STORE_STATE.ERROR,
                error: e,
                loading: false
            });
        }
    };
};
